import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAccessManagementFeatures} from '../../services/getAccessManagementFeatures';
import {UseGetAccessManagementFeaturesQueryParams} from './types';

export function useGetAccessManagementFeaturesQuery({
	enabled,
}: UseGetAccessManagementFeaturesQueryParams = {}) {
	return useQuery({
		queryKey: [QUERY_KEYS.ACCESS_MANAGEMENT_FEATURES],
		queryFn: ({signal}) => getAccessManagementFeatures({signal}),
		enabled,
		retry: 2,
	});
}
